import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

interface DuplicateConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function DuplicateConfirmModal({ open, onClose, onConfirm }: DuplicateConfirmModalProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Duplicar evento</DialogTitle>
      <DialogContent>
        Tem certeza que deseja duplicar este evento?
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={onConfirm} color="primary" variant="contained">Duplicar</Button>
      </DialogActions>
    </Dialog>
  );
}